// src/features/october/hooks/useCart.js
import { useCart as useCartContext } from '../../../context/CartContext';

// Re-export the useCart hook from CartContext
export const useCart = useCartContext;

// Hook for cart persistence and sync
export const useCartPersistence = () => {
  const exportCart = (cartItems) => {
    const cartData = {
      items: cartItems,
      exportedAt: new Date().toISOString(),
      version: '1.0'
    };
    
    const dataStr = JSON.stringify(cartData, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `pontso-yarona-cart-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const importCart = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = (e) => {
        try {
          const cartData = JSON.parse(e.target.result);
          if (cartData.items && Array.isArray(cartData.items)) {
            resolve(cartData.items);
          } else {
            reject(new Error('Invalid cart file format'));
          }
        } catch (error) {
          reject(new Error('Failed to parse cart file'));
        }
      };
      
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsText(file);
    });
  };

  const shareCart = (cartItems) => {
    const cartData = {
      items: cartItems.map(item => ({
        id: item.id,
        name: item.name,
        quantity: item.quantity
      })),
      sharedAt: new Date().toISOString()
    };
    
    const encoded = btoa(JSON.stringify(cartData));
    const shareUrl = `${window.location.origin}/kganya-scents?cart=${encoded}`;
    
    if (navigator.share) {
      navigator.share({
        title: 'My Pontso Yarona Cart',
        text: 'Check out my fragrance selection!',
        url: shareUrl
      });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(shareUrl);
      return shareUrl;
    }
    
    return shareUrl;
  };

  return {
    exportCart,
    importCart,
    shareCart
  };
};

// Re-export the useWishlist hook from CartContext
export { useWishlist } from '../../../context/CartContext';